//Node Modules
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

//BinaryForge Components
import { LineChartDate } from "../";

//3rd Party Components

//Atoms
import { reportParamsAtom } from "../../../atoms/report";

//Helpers
import { safeJsonParse } from "../../../helpers/Json";

//Other

const ReportResultsChart = ({ reportResultsData, timestamps, devices }) => {
	//Hooks
	const { t } = useTranslation();

	//Recoil
	const reportParams = useRecoilValue(reportParamsAtom);

	const deviceMap = useMemo(() => {
		if (!Array.isArray(devices)) return {};
		return devices.reduce((acc, d) => {
			if (d?.id) {
				//zoneBreadcrumb reaches us as the raw JSON string from the API, or already
				//parsed when the devices list came from devicesListSelector. safeJsonParse
				//passes an object straight through, where JSON.parse would throw on it.
				const breadcrumb = safeJsonParse(d.zoneBreadcrumb, null, "zoneBreadcrumb");
				const breadcrumbLabel = breadcrumb?.label?.replaceAll("|", " > ") ?? null;
				acc[d.id] = { name: d.name, zoneBreadcrumb: breadcrumbLabel };
			}
			return acc;
		}, {});
	}, [devices]);

	return (
		<LineChartDate
			data={reportResultsData}
			timestamps={timestamps}
			measureName={t(`report.measure.${reportParams.measureName}`)}
			deviceMap={deviceMap}
		/>
	);
};

export default ReportResultsChart;
